import {gql} from "@apollo/client";

export const GET_ALL_TEAMS = gql`
    query Teams($organizationId: ID!) {
        teams(organizationId: $organizationId) {
            id
            name
            description
            organizationId
            active
            createdAt
            modifiedAt
        }
    }
`;

export const GET_TEAM = gql`
    query Team ($teamId: ID!) {
        team(teamId: $teamId) {
            id
            name
            description
            organizationId
            active
            createdAt
            modifiedAt
        }
    }
`;


export const UPDATE_TEAM = gql`
    mutation UpdateTeam($id: ID!, $input: TeamInput!) {
        updateTeam(id: $id, input: $input) {
            team {
                id
                name
                description
                organizationId
                active
                createdAt
                modifiedAt
            }
            errors {
                message
            }
        }
    }
`;
